import axios from 'axios';
import {properties} from '../resources/properties.js';

// TODO: PARAMETRISALO WEY!
let API_URL = properties.apiURLApiService;
if (window.location.protocol === 'https:' && API_URL.includes('http://'))
  API_URL = API_URL.replace('http://', 'https://')
else if (window.location.protocol === 'http:' && API_URL.includes('https://'))
  API_URL = API_URL.replace('https://', 'http://')
  // const API_URL = 'http:/localhost:8081';

const checkStatus = (response) => {
  // raises an error in case response status is not a success
  if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
    return response;
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};

export const getRequest = (path, data) => {
  const headers = {};
  headers['Accept-Language'] = 'es';

  return axios({method: 'get', url: API_URL, headers: headers, params: data}).then(checkStatus);
};

export const simpleGetRequest = (path) => {
  const headers = {};
  headers['Accept-Language'] = 'es';
  headers["Access-Control-Allow-Origin"] = "*";

  return axios({
    method: 'get',
    url: API_URL + path,
    headers: headers
  }).then(checkStatus);
};

export const postRequest = (path, data, headers = {}) => {

  return axios({method: 'post', url: `${API_URL}${path}`, data: data, headers: headers}).then(checkStatus);
};

export const putRequest = (path, data, headers = {}, config = {}) => {
  headers['Accept-Language'] = 'es-ES,es;q=0.9';

  return axios({
    method: 'put',
    url: API_URL,
    data: data,
    headers: headers,
    ...config
  }).then(checkStatus);
};

export const deleteRequest = (path) => {
  const headers = {};
  headers['Accept-Language'] = 'es';

  return axios({method: 'delete', url: API_URL, headers: headers}).then(checkStatus);
};

export const downloadRequest = (path, headers = {}, data, responseType) => {
  // headers['Accept-Language'] = 'es-ES,es;q=0.9';
  //  headers['Accept'] = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8';
  //
  // return axios({
  //   method: 'post',
  //   url: API_URL + path,
  //   data: JSON.stringify(data),
  //   headers: headers,
  //   responseType: responseType || 'stream',
  //   maxContentLength: 20000090
  // }).then(checkStatus);
  let a = fetch(API_URL + path, {
    "credentials": "omit",
    "headers": {
      "Accept": "application/json, text/plain, */*",
      "Accept-Language": "es-ES,es;q=0.9",
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json"
    },
    "body": JSON.stringify(data),
    "responseType": responseType,
    "method": "POST",
    "timeout": 20000
  });

  return a
};

export const downloadRequestGET = (path, headers = {}, responseType) => {
  let a = fetch(path, {
    "credentials": "omit",
    "headers": {
      "Accept": "application/json, text/plain, */*",
      "Accept-Language": "es-ES,es;q=0.9",
      "Access-Control-Allow-Origin": "*"
    },
    "responseType": responseType,
    "method": "GET",
    "timeout": 20000
  });
  //Opción de timeout no parece que existe en fetch. Usar 100 milisegundos no tuvo efecto.
  return a
};
